/**
 * NOTE: 複数のエリアを囲む緯度経度
 *       バナー表示させたいエリアを囲む緯度経度を連想配列で指定する
 *       例）
 *         {
 *            name: "札幌市",               // 市町村名（利用していない）
 *            area: [                      // 緯度経度のプロット
 *                [43.19184573, 141.40218],
 *                [43.16144757, 141.2236224],
 *                ...
 *            ],
 *            article-url: "https://ensagaso.com/column/article/73054", // バナー記事の URL
 *            banner-img-url: "/static/parent/img/bnr_task_force.png"   // バナー画像の URL
 *         },
 *         {
 *             ...
 *         }
 */
export const bannerDisplayPolygonList = [
    {
        name: "町田市",
        area: [
            [35.5400844, 139.4414854],
            [35.4998073, 139.4661168],
            [35.5023226, 139.4890463],
            [35.553104, 139.492994],
            [35.5758657, 139.5108468],
            [35.6176634, 139.413469],
            [35.6075107, 139.3860461],
            [35.625056, 139.3382189],
            [35.6189912, 139.4505608],
            [35.606209, 139.2575784],
            [35.6248327, 139.2883491],
            [35.582068, 139.3690087]
        ],
        "article-url":
            "/ns/47178?utm_source=ensagaso&utm_medium=banner&utm_campaign=tf&utm_content=map_top_banner_machida",
        "banner-img-url": "/static/parent/img/bnr_task_force_machida.png"
    },
    {
        name: "西東京市",
        area: [
            [35.7032013, 139.5371743],
            [35.7200666, 139.5675584],
            [35.7395758, 139.5734807],
            [35.7638162, 139.5654126],
            [35.7577927, 139.5415273],
            [35.7453579, 139.5248147],
            [35.7278012, 139.5071336],
            [35.7093782, 139.5200421]
        ],
        "article-url":
            "/column/article/70477?utm_source=ensagaso&utm_medium=banner&utm_campaign=tf&utm_content=map_top_banner_nishitokyo",
        "banner-img-url": "/static/parent/img/bnr_task_force_nishi_tokyo.png"
    },
    {
        name: "調布市",
        area: [
            [35.6398308, 139.5276852],
            [35.6300995, 139.5624037],
            [35.6428651, 139.5949765],
            [35.6687231, 139.5967391],
            [35.6857901, 139.5598215],
            [35.6831933, 139.5419687],
            [35.6785615, 139.5374066],
            [35.6931157, 139.5217842],
            [35.6490701, 139.5029617]
        ],
        "article-url":
            "/ns/47177?utm_source=ensagaso&utm_medium=banner&utm_campaign=tf&utm_content=map_top_banner_chofu",
        "banner-img-url": "/static/parent/img/bnr_task_force_tyouhu.png"
    }
];
